import React from "react";
import Slider from "react-slick";
import useStyles, {
  CarouselContainer,
  CarouselIMG,
  FlexDate,
  SpanDot,
  Span,
} from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import logo from "../../assets/images/logo.svg";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  ArrowDropDown,
  Facebook,
  Instagram,
  LinkedIn,
  Mail,
  Person,
  Phone,
  ShareOutlined,
  Storefront,
  Twitter,
  WarehouseOutlined,
} from "@mui/icons-material";
import {
  admin_login,
  contact_us,
  get_area,
  get_banner,
  get_delivery,
  get_gallery,
  get_random_shop,
  login,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate } from "react-router-dom";
import toast from "react-simple-toasts";
import useUser from "../../hooks/useUser";

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { set_user, get_user } = useUser();

  // API

  const [token, setToken] = React.useState([]);

  React.useEffect(() => {
    let token = window.localStorage.getItem("token");
    setToken(token || "");
    console.log("CURRENT TOKEN", token);
  }, []);

  const [loginData, setLoginData] = React.useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = () => {
    if (loginData.email.length === 0) {
      toast("Please enter email");
      return;
    }
    if (loginData.password.length === 0) {
      toast("Please enter password");
      return;
    }
    admin_login(loginData).then((json) => {
      if (json.status) {
        set_user(json.data);
        window.localStorage.setItem("token", json.data.token);
        navigate("/dashboard");
      } else {
        toast(json.message);
      }
    });
    // if (loginData.email.length == "" || loginData.password.length == "") {
    //   alert("All Field Required");
    //   return;
    // }

    // login(loginData).then((json) => {
    //   if (json.status) {
    //     alert(json.message);
    //     navigate("/dashboard");
    //   } else {
    //     alert(json.message);
    //   }
    // });
  };

  return (
    <React.Fragment>
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          transform: "translate(-50%, -50%)",
          left: "50%",
          width: "100%",
        }}
      >
        <div
          style={{
            border: "1px solid #1A5386",
            padding: "2rem",
            borderRadius: "6px",
          }}
        >
          {/* <Paragraph bold="700" size="24px" color="#1A5386" margin="2rem 0" textTransform="uppercase">
            Megah Tex ADMIN PANEL
          </Paragraph> */}
          <div style={{ width: "80%", margin: "0 auto" }}>
            <img style={{ width: "100%" }} src={logo} />
          </div>
          <br/>
          <FormInput
            label="Email"
            textLabelColor="#1A5386"
            placeholder="Email"
            name="email"
            border="1px solid #c5c5c5"
            onChange={handleChange}
          />
          <FormInput
            label="Password"
            textLabelColor="#1A5386"
            placeholder="Password"
            name="password"
            type="password"
            border="1px solid #c5c5c5"
            onChange={handleChange}
          />
          <br />
          <Button
            label="Login"
            bg="#1A5386"
            color="#FFF"
            br="6px"
            pd=".5rem 1rem"
            onClick={() => handleLogin()}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
